import { Box, Button, Grid, Tab, Typography, Breadcrumbs, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomSearchInput from '../common/CustomSearchInput'
import { TabContext, TabPanel } from "@mui/lab";
import { styled } from "@mui/material/styles";
import { useNavigate } from 'react-router-dom';
import { HttpRequest } from '../HttpRequest';
import CurrencyFormatter from '../common/currencyFormatter';
import { Visibility } from '@mui/icons-material';
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import CustomSelect from '../common/customSelectInput';
import { CustomizedDate } from '../common/customDate';
import { startOfToday, startOfYesterday, endOfToday, endOfYesterday, subDays, startOfMonth, endOfMonth, subMonths, format } from 'date-fns';
import ExportData from '../common/exportData';
import OrderStatus from './orderStatus';
import CustomTabList from '../common/CustomTabList';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";


const getLastMonthRange = (date) => {
  const previousMonth = subMonths(date, 1);
  const start = startOfMonth(previousMonth);
  const end = endOfMonth(previousMonth);
  return { start, end };
};

const Orders = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [search, setSearch] = useState('')
  const [tabValue, setTabValue] = useState('all');
  const [dataGridPageSize, setPageSize] = useState(10);
  const [pageState, setPageState] = useState({ isLoading: true, data: [], total: 0, page: 1, pageSize: dataGridPageSize, })
  const [paymentStatus, setPaymentStatus] = useState('paid');
  const [deliveryMethod, setDeliveryMethod] = useState('');
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [orderType, setOrderType] = useState('');
  const navigate = useNavigate();
  const [dataToExport, setDataToExport] = useState([]);
  const [tableColumns, setTableColumns] = useState([
    {
      field: 'orderNumber',
      headerName: 'Order Number',
    },
    {
      field: 'customerName',
      headerName: 'Customer Name',
    },
    {
      field: 'status',
      headerName: 'Payment Status',
    },
    {
      field: 'date',
      headerName: 'Date',
    },
    {
      field: 'orderStatus',
      headerName: 'Order Status',
    },
    {
      field: 'itemsCount',
      headerName: 'No. of Items',
    },
    {
      field: 'amount',
      headerName: 'Amount',
    },
    {
      field: 'customerAddress',
      headerName: 'Customer Address',
    },
  ]);

  const tabs = [
    { label: "All", value: "all" },
    { label: "Received", value: "Received" },
    { label: "Processing", value: "Processing" },
    { label: "Ready To Ship", value: "ReadyToShip" },
    { label: "Shipped", value: "Shipped" },
    { label: "Delivered", value: "Delivered" },
    { label: "Pending", value: "Pending" },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', padding: '8px' }}>
        <ExportData data={dataToExport} tableColumn={tableColumns} title={`Orders Export`} />
      </GridToolbarContainer>
    );
  }

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const formatDate = (value) => {
    const dateString = value;
    const date = new Date(dateString);

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const time = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    return `${month} ${day}, ${year} ${time}`;
  };
  const handleRowClick = (event, rowId) => {
    event.stopPropagation();
    navigate(`/zed_ecommerce/orders/${rowId}/details`)
  }

  const columns = [
    {
      field: 'orderNumber', headerName: 'order Number', flex: isMobile ? 0.8 : 1.1, minWidth: 70,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Order No.</Box>) },
      renderCell: (params) => {
        return (
          <Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }} > {params?.row?.orderNumber}  </Box>)
      }
    },
    {
      field: 'createdAt', headerName: 'Date', flex: isMobile ? 1.5 : 2,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Date</Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {formatDate(params?.row?.createdAt)}
        </Box>)
      }
    },
    {
      field: 'customerName', headerName: 'Customer Name', flex: isMobile ? 1.2 : 1.5,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>Customer Name</Box>) },
      renderCell: (params) => { return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>{params?.row?.customerName}  </Box>) }
    },
    {
      field: 'customerAddress', headerName: 'Delivery Address', flex: isMobile ? 1.2 : 1.5,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Delivery Address  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {typeof params?.row?.customerAddress === 'object' && params?.row?.customerAddress !== null ? (
            <>
              {params?.row?.customerAddress?.address && <div>{params?.row?.customerAddress?.address}</div>}
              {params?.row?.customerAddress?.apartment && <div>{params?.row?.customerAddress?.apartment}</div>}
              {params?.row?.customerAddress?.city && <div>{params?.row?.customerAddress?.city}</div>}
            </>
          ) : (
            params?.row?.customerAddress
          )}
        </Box>)
      }
    },
    {
      field: 'itemsCount', headerName: 'Items', flex: isMobile ? 0.6 : 0.8,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Items  </Box>) },
      renderCell: (params) => { return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>    {params?.row?.itemsCount}  </Box>) }
    },
    {
      field: 'amount', headerName: 'Amount', flex: isMobile ? 0.8 : 1, minWidth: 70,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Amount  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
          {CurrencyFormatter(params?.row?.amount-params?.row?.shippingAmount, 'KES')}
        </Box>)
      }
    },
    {
      field: 'shippingAmount', headerName: 'Shipping Amount', flex: isMobile ? 1.2 : 1.5, 
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Shipping Amount  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
         {params?.row?.shippingAmount === 0 ? 'N/A' : CurrencyFormatter(params?.row?.shippingAmount, 'KES')}
        </Box>)
      }
    },
    {
      field: 'total', headerName: 'Total Amount', flex: isMobile ? 1.2 : 1.5,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Total Amount  </Box>) },
      renderCell: (params) => {
        return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "600" }}>
          {CurrencyFormatter(params?.row?.amount, 'KES')}
        </Box>)
      }
    },
    {
      field: 'paymentStatus', headerName: 'Payment Status', flex: isMobile ? 1.2 : 1.5, 
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Payment Status  </Box>) },
      renderCell: (params) => { return (<Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: getStatusColor(params), fontSize: isMobile ? "11px" : "14px", fontWeight: "600", textTransform: 'capitalize' }}> {params?.row?.status}  </Box>) }
    },
    {
      field: 'status',
      headerName: 'Order Status',
      flex: isMobile ? 1.1 : 1.3, minWidth: 100,
      renderHeader: (params) => (
        <Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}>
          Order Status
        </Box>
      ),
      renderCell: (params) => (
        <Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer' }}>
          <OrderStatus onClick={(event) => handleRowClick(event, params?.row?._id)} orderStatus={params.row?.orderStatus} deliveryMethod={params.row?.deliveryMethod || 'ship'} />
        </Box>
      )
    },
    {
      field: 'action', headerName: 'Action', flex: isMobile ? 0.5 : 0.6,
      renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "14px" : "17px", fontWeight: "700" }}>   </Box>) },
      renderCell: (params) => {
        return (
          <Box onClick={(event) => handleRowClick(event, params?.row?._id)} style={{ cursor: 'pointer', color: '#707070', fontSize: isMobile ? "13px" : "15px", fontWeight: "500", marginTop: isMobile ? '5px' : '10px' }}>
            <Visibility onClick={() => { navigate(`/zed_ecommerce/orders/${params?.row?._id}/details`) }} />
          </Box>)
      }
    },
  ]
  function getStatusColor(params) {
    const statusColors = {
      'paid': '#17ae7b',
      'unpaid': '#dc3545',
    };
    return statusColors[params?.row?.status] || '#dc3545';
  }
  const sanitizeSearchQuery = (query) => {
    return query.replace(/\D/g, '');
  };
  const getOrders = () => {
    setPageState((old) => ({ ...old, isLoading: true }));

    let status = tabValue === 'all' ? '' : tabValue;
    const url = `/api/v1/ecommerce/orders?page=${pageState.page}&limit=${pageState.pageSize}&orderStatus=${status}&searchValue=${sanitizeSearchQuery(search)}&status=${paymentStatus}&startDate=${from ?? ''}&endDate=${to ?? ''}&deliveryMethod=${deliveryMethod}&isPreOrder=${orderType}`;

    HttpRequest({
      method: 'GET',
      url: url,
    }).then((data) => {
      setPageState({
        ...pageState,
        data: data?.response?.data,
        total: data?.response?.count,
        isLoading: false
      });
      getDataToExport(data?.response?.count, status, search, paymentStatus, from, to, deliveryMethod, orderType);
    }).catch((error) => {
    });
  };

  const getDataToExport = (limit, status, search, paymentStatus, from, to, deliveryMethod, orderType) => {
    const url = `/api/v1/ecommerce/orders?page=${pageState.page}&limit=${limit}&orderStatus=${status}&searchValue=${sanitizeSearchQuery(search)}&status=${paymentStatus}&startDate=${from ?? ''}&endDate=${to ?? ''}&deliveryMethod=${deliveryMethod}&isPreOrder=${orderType}`;
    return HttpRequest({
      method: 'GET',
      url: url
    }).then((data) => {
      const filteredOrders = data?.response?.data?.map(({ _id, userId, customerAddress, createdAt, ...rest }) => ({
        ...rest,
        date: formatDate(createdAt),
        customerAddress: `${customerAddress?.address ?? ''}, ${customerAddress?.city ?? 'N/A'}, ${customerAddress?.apartment ?? 'N/A'}, ${customerAddress?.county ?? 'N/A'}, ${customerAddress?.postalCode ?? 'N/A'}`
      }));
      setDataToExport(filteredOrders);
      return filteredOrders;
    }).catch((error) => {
      throw error;
    });
  };


  const [range, setRange] = useState('');
  const status = [
    { id: 2, label: 'Paid', value: 'paid' },
    { id: 3, label: 'Unpaid', value: 'unpaid' },
    { id: 4, label: 'Partially Paid', value: 'partial' },
  ];
  const methods = [
    { id: 3, label: 'Delivery', value: 'ship' },
    { id: 4, label: 'Pickup', value: 'pickup' },
  ];
  const types = [
    { id: 3, label: 'Orders', value: false },
    { id: 4, label: 'Pre-Orders', value: true },
  ];
  const ranges = [
    { id: 1, label: 'Select Date', value: '' },
    { id: 2, label: 'Today', value: 'today' },
    { id: 3, label: 'Yesterday', value: 'yesterday' },
    { id: 4, label: 'Last 7 Days', value: 'oneWeek' },
    { id: 5, label: 'This Month', value: 'thisMonth' },
    { id: 6, label: 'Last Month', value: 'lastMonth' },
    { id: 7, label: 'Custom Range', value: 'customDate' },
  ];
  useEffect(() => {
    getOrders()
  }, [tabValue, search, dataGridPageSize, pageState.page, paymentStatus, to, from, deliveryMethod, orderType])
  useEffect(() => {
    const updateDates = (range) => {
      const today = new Date();
      let fromDate = null;
      let toDate = null;

      switch (range) {
        case 'today':
          fromDate = format(startOfToday(), 'MM/dd/yyyy');
          toDate = format(endOfToday(), 'MM/dd/yyyy');
          break;
        case 'yesterday':
          fromDate = format(startOfYesterday(), 'MM/dd/yyyy');
          toDate = format(endOfYesterday(), 'MM/dd/yyyy');
          break;
        case 'oneWeek':
          fromDate = format(subDays(today, 7), 'MM/dd/yyyy');
          toDate = format(endOfToday(), 'MM/dd/yyyy');
          break;
        case 'thisMonth':
          fromDate = format(startOfMonth(today), 'MM/dd/yyyy');
          toDate = format(endOfMonth(today), 'MM/dd/yyyy');
          break;
        case 'lastMonth':
          ({ start: fromDate, end: toDate } = getLastMonthRange(today));
          fromDate = format(fromDate, 'MM/dd/yyyy');
          toDate = format(toDate, 'MM/dd/yyyy');
          break;
        default:
          fromDate = null;
          toDate = null;
          break;
      }

      setFrom(fromDate);
      setTo(toDate);
    };

    updateDates(range);
  }, [range]);

    const breadcrumbs = [
      <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml:3 }}>
          Dashboard
      </Typography>,
      <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
        Orders
      </Typography>
  ];


  return (
    <Box sx={{ mt: { xs: "15%", sm: "5%" }, pr: "3.5%", width: { xs: "100vw", sm: "calc(100vw - 380px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3, sm: 0 } }}>      
      <Box>
        <Typography variant='h4' sx={{ color: "#032541", fontSize: { xs: "18px", sm: "22px", md: "26px" }, fontStyle: "normal", fontWeight: "600" }}>Orders</Typography>
      </Box>
    <Grid item sx={{ mt: 1, mb: { xs: -1, sm: 1 }, ml: { xs: -3, sm: -3 } }}>
        <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
            {breadcrumbs}
        </Breadcrumbs>
    </Grid>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '10px', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 0 } }}>
        <CustomSearchInput placeholder={"Search Orders Id"} name="search" sm={"sm"} value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: '100%', sm: 'auto' }, mt:-0.8 }} />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: { xs: 'wrap', sm: 'nowrap' }, justifyContent: { xs: 'flex-start', sm: 'flex-end' }, width: { xs: '100%', sm: 'auto' } }}>
          <CustomSelect sx={{ mt: '8px' }} value={orderType} placeholder='Order Type' options={types} sm={"xs"} onChange={(e) => setOrderType(e.target.value)} />
          <CustomSelect sx={{ mt: '8px' }} value={deliveryMethod} placeholder='Delivery Method' options={methods} sm={"xl"} onChange={(e) => setDeliveryMethod(e.target.value)} />
          <CustomSelect sx={{ mt: '8px' }} value={paymentStatus} options={status} sm={"xs"} onChange={(e) => setPaymentStatus(e.target.value)} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: { xs: 'wrap', sm: 'nowrap' } }}>
            <CustomSelect
              sx={{ mt: '8px' }}
              value={range}
              options={ranges}
              sm={"sm"}
              onChange={(e) => setRange(e.target.value)}
            />
            {range === 'customDate' && (
              <CustomizedDate setDateFrom={setFrom} setDateTo={setTo} style={{ display: "flex", alignItems: "center" }} />
            )}
          </Box>
        </Box>
      </Box>
      <TabContext value={tabValue}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: '10px', flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 2, sm: 0 } }}>
          <Box sx={{ width: { xs: '100%', sm: 'auto' }, overflowX: 'auto' }}>
            <CustomTabList tabs={tabs} onChange={handleChange} />
          </Box>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <ExportData data={dataToExport} tableColumn={tableColumns} title={`Orders Export`} />
          </Box>
        </Box>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
          <TabPanel value="all" sx={{ p: 0, m: 0 }}>
            <Grid item>
              <DataGrid
                  sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px', }}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="Received" sx={{ p: 0, m: 0 }}>
            <Grid item>
              <DataGrid
                sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="Processing" sx={{ p: 0, m: 0 }}>
            <Grid item>
              <DataGrid
                sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="ReadyToShip" sx={{ p: 0, m: 0 }}>
            <Grid item>
              <DataGrid
                sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="Shipped" sx={{ p: 0, m: 0 }}>
            <Grid item>
              <DataGrid
                sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="Delivered" sx={{ p: 0, m: 0 }}>
            <Grid item>
              <DataGrid
                sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px',}}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Grid>
          </TabPanel>
          <TabPanel value="Pending" sx={{ p: 0, m: 0 }}>
            <Grid item>
              <DataGrid
                sx={{ minHeight: '500px', height: 'auto', width: 'auto', fontFamily: 'Poppins', fontSize: isMobile ? '10px' : '12px', color: '#272d3d', boxShadow: 0, border: 0, '& .MuiDataGrid-cell': { fontSize: isMobile ? '10px' : '12px', }}}
                rowCount={pageState.total}
                pagination
                loading={pageState.isLoading}
                page={pageState.page - 1}
                pageSizeOptions={[1, 10, 20, 50, 100]}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: dataGridPageSize,
                      page: pageState.page - 1,
                    },
                  },
                }}
                pageSize={dataGridPageSize}
                onPaginationModelChange={(data) => {
                  const { pageSize, page } = data;
                  setPageState((old) => ({ ...old, page: page + 1, pageSize: pageSize }));
                  setPageSize(pageSize)
                }}
                paginationMode="server"
                columns={columns}
                rows={pageState.data}
                getRowId={(row) => row._id}
              />
            </Grid>
          </TabPanel>
          </Box>
        </Box>
      </TabContext>
    </Box>
  )
}

export default Orders